import { Component, Input } from '@angular/core';
import { PendingProductionManagerApprovalCounts } from 'src/app/core/interfaces/status-counts/pending-production-manager-approval-counts';

@Component({
  selector: 'app-pending-production-manager-approval-counts',
  templateUrl: './pending-production-manager-approval-counts.component.html',
  styleUrls: ['./pending-production-manager-approval-counts.component.scss'],
})
export class PendingProductionManagerApprovalCountsComponent {
  @Input() counts: PendingProductionManagerApprovalCounts;
}
